import styled from 'styled-components'

export const Wrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 12px;
  background: #f3f3f5;
  border-bottom: 1px solid #b7b8c1;
  border-top: 1px solid #b7b8c1;
  height: 133px;
`
export const EmptyAwards = styled.div`
  text-align: center;
  font: var(--typography-12-18-regular);
  font-style: italic;
  color: var(--color-sw-60);
  width: 320px;
`
export const WineDescription = styled.div`
  font: var(--typography-12-18-semibold);
  font-style: italic;
  color: #717284;
  max-width: 320px;
  min-width: 130px;
  overflow: hidden;
  max-height: 130px;
  text-align: ${props => props.align};
  margin-left: ${props => (props.align === 'left' ? '50px' : 0)};
`
